import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './Tabs.module.scss';

interface Props {
  labels: string[];
  children: React.ReactNode | React.ReactNode[];
}

const Tabs = ({ labels, children }: Props) => {
  const [activeTab, setActiveTab] = useState<number>(0);
  return (
    <div className={styles.Tabs}>
      <nav className={styles.nav}>
        {(labels || []).map((item, index) => (
          <div className={styles.navItem} key={index}>
            <button type="button"
              onClick={() => setActiveTab(index)}
              className={classnames(
                styles.label,
                index === activeTab && styles.activeLabel,
              )}
            >
              {item}
            </button>
          </div>
        ))}
      </nav>
      <div className={styles.content}>
        {Array.isArray(children)
          ? (children || []).map((item: React.ReactNode, index) =>
              index === activeTab ? item : null,
            )
          : children}
      </div>
    </div>
  );
};

export default Tabs;
